import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import StyleSheet from "react-native-media-query";
import CommonStyle from "../../assets/styles/common-style";
import { CROSS_ICON } from "../../resources/IMAGES";
import { theme } from "../../theme/theme";

const Banner = (props: any) => {
  const bannerObject = props?.banner;

  return (
    <>
      {bannerObject?.message?.body && (
        <View
          style={[styles.banner, CommonStyle.styles.rowFlex]}
          dataSet={{ media: ids.banner }}
        >
          <Text style={styles.bannerText} dataSet={{ media: ids.bannerText }}>
            {bannerObject?.message?.body}
            {/* message */}
          </Text>

          <TouchableOpacity
            onPress={() => props.onItemPress()}
            style={styles.crossIconTouch}
          >
            <Image
              style={styles.crossIcon}
              dataSet={{ media: ids.crossIcon }}
              source={CROSS_ICON}
            />
          </TouchableOpacity>
        </View>
      )}
    </>
  );
};

const { ids, styles } = StyleSheet.create({
  crossIcon: {
    width: 20,
    height: 20,
    "@media (min-width: 700px)": {
      // iPad Pro 9.7
      width: 18,
      height: 18,
    },
    "@media (min-width: 1000px)": {
      //iPad Pro 12.9
      width: 24,
      height: 24,
    },
  },
  crossIconTouch: {
    width: 44,
    height: 44,
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    right: 4,
    top: 0,
  },
  banner: {
    zIndex: 9,
    elevation: 99,
    width: "100%",
    backgroundColor: theme.colors.banner,
    textAlign: "left",
    justifyContent: "flex-start",
    padding: theme.spacing.reg,
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.xxl3,
  },
  bannerText: {
    color: theme.colors.white,
    fontSize: theme.fontsize.cs,
    width: "100%",
    textAlign: "center",
  },
  closeText: {
    color: theme.colors.white,
  },
});

export default Banner;
